// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1nywX","left":"InfoRow_left__2B_sJ"};